var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.275 8.46874C11.0125 8.72499 10.8625 9.09375 10.9 9.4875C10.9563 10.1625 11.575 10.6562 12.25 10.6562H13.4375V11.4C13.4375 12.6937 12.3812 13.75 11.0875 13.75H3.9125C2.61875 13.75 1.5625 12.6937 1.5625 11.4V7.19376C1.5625 5.90001 2.61875 4.84375 3.9125 4.84375H11.0875C12.3812 4.84375 13.4375 5.90001 13.4375 7.19376V8.09376H12.175C11.825 8.09376 11.5063 8.23124 11.275 8.46874Z",
    stroke: "#30322C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5625 7.75619V4.89997C1.5625 4.15622 2.01875 3.4937 2.7125 3.2312L7.675 1.3562C8.45 1.06245 9.28125 1.63746 9.28125 2.46871V4.84371",
    stroke: "#30322C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1002 8.73135V10.0189C14.1002 10.3626 13.8252 10.6439 13.4752 10.6564H12.2502C11.5752 10.6564 10.9565 10.1626 10.9002 9.48761C10.8627 9.09386 11.0127 8.72511 11.2752 8.46886C11.5065 8.23136 11.8252 8.09387 12.1752 8.09387H13.4752C13.8252 8.10637 14.1002 8.3876 14.1002 8.73135Z",
    stroke: "#30322C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 7.5H8.75",
    stroke: "#30322C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet2);
export default __webpack_public_path__ + "static/media/wallet2.47787e819b60a4939897a4d67154df64.svg";
export { ForwardRef as ReactComponent };